import { useTrackingPage } from "./all-pages";
import { useProductSearchStore } from '@/store/product-search';
import { useInteractionDoneTracking } from "./interaction-done";

export const useTrackingRecherche = () => {

  const { $partenairesEvents } = useNuxtApp();

  const { query, params } = useRoute();

  const { productsCount, fromWordSuggestion } = storeToRefs(useProductSearchStore());
  const { setFromWordSuggestion } = useProductSearchStore();

  const { trackPage } = useTrackingPage();
  const { trackEvent } = useInteractionDoneTracking();


  const labelGA = computed(() => {
    return productsCount.value > 0
      ? trackingCodes.LABELGA.resultOK
      : trackingCodes.LABELGA.resultKO;
  });

  const trackRecherche = () => {
    trackPage(trackingCodes.PAGETYPE.search);
    trackEvent({
      actionGA: query.keywords,
      categoryGA: fromWordSuggestion.value ? trackingCodes.CATEGORYGA.vousVoulezDire : trackingCodes.CATEGORYGA.internResearch,
      labelGA: labelGA.value
    });
    setFromWordSuggestion(false);
  }

  const emitEventPartenaires = () => {
    if (process.client) {
      if (
        typeof window.cora.partenaires.router.onProductsListLoaded !== "undefined"
      ) {
        $partenairesEvents.dispatch(
          "products-list-loaded",
          {
            context: "recherche-produits",
            page: query.pageindex ? query.pageindex : "1",
            perPage: productsCount.value,
            sort: params.filtersQuery
          },
          true
        );
      }
    }
  }

  return { trackRecherche, emitEventPartenaires }
}
